import { memo } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

import { Card, CardContent, Typography } from '@mui/material';

import { classNames } from '../../../../../utils';

export const StepItem = memo((props) => {
  const { active, imgUrl, message, stepNumber } = props;
  const { t } = useTranslation();

  const res = active ? '.gif' : '.png';
  const mods = {
    active,
  };

  return (
    <Card className={classNames('step-instruction', { ...mods })}>
      <img className='fade-in' alt='not-found' src={`${imgUrl}${res}`} />
      <CardContent>
        <Typography className='desc' variant='h3'>
          <span>{`${t('device-connection.step')} ${stepNumber} `}</span>
          {t(message)}
        </Typography>
      </CardContent>
    </Card>
  );
});
